import React from "react";
import classes from "../../styles/Gallery.module.css";
import "react-image-lightbox/style.css";

const GalleryImage = ({ src, handleClick }) => {
  return (
    <img
      src={src}
      alt=""
      className={classes.GalleryImage}
      onClick={handleClick}
    />
  );
};

export default GalleryImage;
